module.exports = __webpack_public_path__ + "img/temperature-low.e33774d4.svg";